import React, { isValidElement, useRef } from 'react';
import { GENERAL_JOB_CODE } from 'Custom/Footer/Footer.utils.js';
import BaseLayout from 'Nori/Layout/BaseLayout';
import Footer from 'Custom/Footer';
import Header from 'Custom/Header';
import StickyNavigation from 'Custom/Header/StickyNavigation';
import ISIFooter from 'Custom/ISI/ISIFooter';
import ISIBar from 'Custom/ISIBar';
import ExternalLinkModal from 'Custom/Modal/ExternalLinkModal';
import HealthcareModal from 'Custom/Modal/HealthcareModal';
import ISIModal from 'Custom/Modal/ISIModal';
import { FOCUS_TRACKING_CLASS } from 'Utils/hooks/useFocusAlwaysVisible';
import ModalPDF from 'Custom/ModalPDF';
import { useAppContext } from 'Providers/App';
import { UI_ELEMENTS } from 'Providers/App/elements';

const PageReference = () => null;
const Layout = ({
  reference: Reference = PageReference,
  className = '',
  hideISI = false,
  basic = false,
  loginButton = false,
  logoutButton = false,
  jobCode = GENERAL_JOB_CODE,
  showChatbox = true,
  showFooterNav = false,
  hideBrandFooter = false,
  children,
  ...props
}) => {
  const { getElementState } = useAppContext();
  const isiRef = useRef(null);
  const pageableModalPDF = getElementState(UI_ELEMENTS.pageableModalPDF);

  return (
    <BaseLayout
      isiRef={isiRef}
      {...props}
      showChatbox={showChatbox}
      data-qa-tag="base-layout-section"
    >
      <Header
        basic={basic}
        loginButton={loginButton}
        logoutButton={logoutButton}
        data-qa-tag="page-header"
      />
      {!hideISI && <ISIBar />}
      <StickyNavigation basic={basic} data-qa-tag="sticky-navigation" />

      <div className={FOCUS_TRACKING_CLASS} data-qa-tag="focus-tracking">
        <main className={className} data-qa-tag="page-main-content">
          {children}
        </main>
        {!hideISI && isValidElement(<Reference />) && (
          <ISIFooter
            reference={Reference}
            ref={isiRef}
            data-qa-tag="isi-footer-section"
          />
        )}
        <Footer
          basic={basic}
          showFooterNav={showFooterNav}
          jobCode={jobCode}
          data-qa-tag="page-footer"
        />
      </div>

      <ISIModal data-qa-tag="isi-modal" />
      <ExternalLinkModal data-qa-tag="external-link-modal" />
      <HealthcareModal data-qa-tag="health-care-modal" />
      <ModalPDF paginator={pageableModalPDF} data-qa-tag="pdf-link-modal" />
    </BaseLayout>
  );
};

export default Layout;
